import React from "react";
import "./Faq.css";
import { useStateValue } from "./StateProvider";
import { generateAuthUrl } from "./spotify";

// FAQ Schema.org structured data for SEO
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is Song Carousel?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Song Carousel is a Platfrom where Musicians who have songs on Spotify can get free plays and ratings on their songs."
      }
    },
    {
      "@type": "Question",
      "name": "How does it work? How can I add a song to the Song Carousel?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Listen and rate 5 songs (or 4 songs) and you will be taken to a form where you can add your song."
      }
    },
    {
      "@type": "Question",
      "name": "Is Song Carousel free to use?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes absolutely. We have a premium tier (USD 2.99/month) with some benefits. But everything can be done also within the free tier."
      }
    },
    {
      "@type": "Question",
      "name": "Can other Users see what ratings I gave?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No, they just see the rating itself, not who gave it. But please still be fair and honest when giving ratings."
      }
    },
    {
      "@type": "Question",
      "name": "Can others see what ratings I have received?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No, only YOU see the ratings your receive."
      }
    },
    {
      "@type": "Question",
      "name": "What is required to use the Song Carousel",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You need a Spotify Premium Account in order to use it."
      }
    },
    {
      "@type": "Question",
      "name": "Is Song Carousel related to Spotify?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No. It is not related to Spotify. It is just a 3rd Party Application that uses the Spotify API."
      }
    },
    {
      "@type": "Question",
      "name": "Will I see my own Songs in my Song Carousel?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No, you will never see your own Songs in your Song Carousel. Only other Users see your Song in their Carousel. This way you will get real plays from others on your song."
      }
    },
    {
      "@type": "Question",
      "name": "How many plays/ratings will get per song I added?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Each Song will receive at least 5 plays/ratings each time it gets added."
      }
    },
    {
      "@type": "Question",
      "name": "Can I add the same song several time so it will get more plays.",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes absolutely. If you add the same song several times it will receive more plays/ratings (eg. Song xy gets added 3 times: It will receive at least 15 plays/ratings)."
      }
    },
    {
      "@type": "Question",
      "name": "Do my song(s) need to be on Spotify in order for me to be able to add them?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, your song(s) need to be on Spotify. That's why the song(s) will get real Spotify streams."
      }
    },
    {
      "@type": "Question",
      "name": "Is it secure to connect my Spotify Account in order to use Songcarousel.com?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, Songcarousel.com uses Spotify's secure oAuth 2.0 for authentication, handled entirely by Spotify. We never see or store your password."
      }
    },
    {
      "@type": "Question",
      "name": "Can I undo the Login / Connection to Song Carousel?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes! You can revoke Song Carousel's access to your Spotify account at any time. Under https://www.spotify.com/us/account/apps/ you can see and revoke all apps connected to your Spotify account."
      }
    },
    {
      "@type": "Question",
      "name": "Does any information about the ratings go from Song Carousel to Spotify?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No, only you see the ratings you receive. Spotify only sees regular Song Plays. No information about your Songcarousel.com ratings goes to Spotify."
      }
    }
  ]
};
// import Timer from "./Timer";
// import SongRow from "./SongRow";
// import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
// import FavoriteIcon from "@material-ui/icons/Favorite";
// import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
// import { testTrackThree } from "./testtrack";


// import { AlternateEmail } from "@material-ui/icons";
// import TrackResult from "./TrackResult";
//import SearchResults from "./jammming-src/Components/SearchResults/SearchResults";
//import TrackList from "./jammming-src/Components/TrackList/TrackList";
//import Track from "./jammming-src/Components/Track/Track";

function FaqSlideBody ({ spotify }) {
  const [{ token, firebaseUser }] = useStateValue();

  const handleSpotifyConnect = async () => {
    try {
      const authUrl = await generateAuthUrl();
      window.location.href = authUrl;
    } catch (err) {
      console.error("Error generating Spotify auth URL:", err);
    }
  };

// function backToCarousel() {






// //AUTOPLAY FOOTER AUSSCHALTEN
// dispatch({
//   type: "SET_AUTOPLAYFOOTER",
//   showAutoPlayFooter: false,
//    });





//     //CHEATCHECK SONG ZU AUSGANGSLAGE START

    

//           //song cheating chekck zu ausgangslage start
        
        
//           dispatch({
//             type: "SET_INFOSONGPLAYING",
//             infoSongPlaying:
          
//             //ID WICHTIG FUER CHEATUEBERWACHUNG
//           {
          
          
//             "is_playing": false, //wichtig wegen cheating
          
//                  "item": {
          
           
          
//                 "id": "ischeating",  //WICHTIG FUER CHEATUEBERWACHUNG
//                 "name": "check is cheating",
          
//                 }
//           },
          
          
//           }) //song cheating chekck zu ausgangslage ende
          
       
  
//           //CHEATCHECK SONG ZU AUSGANGSLAGE ENDE

//           dispatch({
//               type: "SET_AUTOPLAYSONG",
//               autoPlaySong: "false",
//           })

          
//           dispatch({
//             type: "SET_PLAYBLOCKER",
//             playBlocker: null,

//           })


//           dispatch({
//             type: "SET_DBLESENCOMINGMENU",
//             dblesencomingfrommenu:1,
//           });
 

   
//     //LADEN DER SONG HINZUFÜGEN MASKE, WENN GENUG SONGS GERATED
//    //ChooseSong.js wird geladen
//       dispatch({
//         type: "SET_MENUSTATE",
//         menustate: "feedbackcarouselmenu",
//       });

    
  

//    if (token && menustate==="feedbackcarouselmenu") return <FeedbackCarousel spotify={spotify}/>


// }


  return (


    <div className="body">
      {/* JSON-LD Schema for FAQ */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <div className="song__thatWillBeAdded">
        <h1>FAQ <span role="img" aria-label="faq">🙋🙋🏽🙋🏻</span> </h1>

        {firebaseUser && !token ? (
          // Logged into Firebase but not connected to Spotify
          <div style={{ textAlign: 'center', margin: '30px 0' }}>
            <button onClick={handleSpotifyConnect} className="landing-login-btn" style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px',
              backgroundColor: '#90ee90',
              color: '#000000',
              padding: '16px 32px',
              fontSize: '16px',
              fontWeight: '700',
              textDecoration: 'none',
              borderRadius: '0',
              boxShadow: 'none',
              cursor: 'pointer',
              border: 'none',
              transition: 'all 0.3s ease'
            }}>
              <svg style={{ width: '24px', height: '24px' }} viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
              </svg>
              CONNECT WITH SPOTIFY PREMIUM
            </button>
            <p style={{ fontSize: '13px', color: '#888', marginTop: '16px', lineHeight: '1.5' }}>
              Connecting is safe. Song Carousel uses Spotify's secure OAuth 2.0 login, handled entirely by Spotify. We never see or store your password.
            </p>
          </div>
        ) : !firebaseUser && (
          // Not logged into Firebase at all
          <div style={{ textAlign: 'center', margin: '30px 0' }}>
            <a href="/" className="landing-login-btn" style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px',
              backgroundColor: '#90ee90',
              color: '#000000',
              padding: '16px 32px',
              fontSize: '16px',
              fontWeight: '700',
              textDecoration: 'none',
              borderRadius: '0',
              boxShadow: 'none',
              cursor: 'pointer',
              border: 'none',
              transition: 'all 0.3s ease'
            }}>
              START HERE
            </a>
            <p style={{ fontSize: '13px', color: '#888', marginTop: '16px', lineHeight: '1.5' }}>
              Get started by logging in to Song Carousel
            </p>
          </div>
        )}

        <h2>

        <p>&nbsp;</p>

            
        <p>1) What is Song Carousel?</p>
            <p>&nbsp;</p>
            <div className="answer"><p>Song Carousel is a Platfrom where Musicians who have songs on Spotify can get free plays and ratings on their songs.</p></div>
            <p>&nbsp;</p>
            

                        <p>2) How does it work? How can I add a song to the Song Carousel?</p>
            <p>&nbsp;</p>
            <div className="answer"><p>Listen and rate 5 songs (or 4 songs) and you will be taken to a form where you can add your song.</p></div>
            <p>&nbsp;</p>


            <p>3) Is Song Carousel free to use?</p>
            <p>&nbsp;</p>
            <div className="answer"><p>Yes absolutely. We have a premium tier (USD 2.99/month) with some benefits. But everything can be done also within the free tier.</p></div>
            <p>&nbsp;</p>

            <p>4) Can other Users see what ratings I gave?</p>
            <p>&nbsp;</p>
            <div className="answer"><p>No, they just see the rating itself, not who gave it. But please still be fair and honest when giving ratings.</p></div>
            <p>&nbsp;</p>

            <p>5) Can others see what ratings I have received?</p>
            <p>&nbsp;</p>
            <div className="answer"><p>No, only YOU see the ratings your receive. </p></div>
            <p>&nbsp;</p>


            <p>6) What is required to use the Song Carousel</p>
            <p>&nbsp;</p>
            <div className="answer"><p>You need a Spotify Premium Account in order to use it.</p></div>
            <p>&nbsp;</p>
     

                <p>
                    7) Is Song Carousel related to Spotify? </p>
                 <p>&nbsp;</p>
                 <div className="answer"><p>No. It is not related to Spotify. It is just a 3rd Party Application that uses the Spotify API.</p></div>
                    <p>&nbsp;</p>

                    <p>
                    8) Will I see my own Songs in my Song Carousel? </p>
                 <p>&nbsp;</p>



 
 
                 <div className="answer"><p>No, you will never see your own Songs in your Song Carousel. Only other Users see your Song in their Carousel.<br />
                This way you will get real plays from others on your song.</p></div>
            <p>&nbsp;</p>

            <p>9) How many plays/ratings will get per song I added?</p>
            <p>&nbsp;</p>
            <div className="answer"><p>Each Song will receive at least 5 plays/ratings each time it gets added.</p></div>
            <p>&nbsp;</p>
    
            
            <p>10) Can I add the same song several time so it will get more plays.</p>
            <p>&nbsp;</p>
            <div className="answer"><p>Yes absolutely. If you add the same song several times it will receive more plays/ratings (eg. Song xy gets added 3 times: It will receive at least 15 plays/ratings).</p></div>
            <p>&nbsp;</p>

            <p>11) Do my song(s) need to be on Spotify in order for me to be able to add them?</p>
            <p>&nbsp;</p>
            <div className="answer"><p>Yes, your song(s) need to be on Spotify. That's why the song(s) will get real Spotify streams.</p></div>
            <p>&nbsp;</p>

             <p>12) Is it secure to connect my Spotify Account in order to use Songcarousel.com?</p>
            <p>&nbsp;</p>
            <div className="answer"><p>Yes, Songcarousel.com uses Spotify's secure oAuth 2.0 for authentication, handled entirely by Spotify. 
          We never see or store your password.</p></div>
            <p>&nbsp;</p>

          <p>13) Can I undo the Login / Connection to Song Carousel?</p>
            <p>&nbsp;</p>
            <div className="answer"><p>Yes! You can revoke Song Carousel's access to your Spotify account at any time. Under <a href="https://www.spotify.com/us/account/apps/" target="_blank" rel="noreferrer" style={{ color: '#ffffff', textDecoration: 'underline' }}>https://www.spotify.com/us/account/apps/</a> you can see and revoke all apps connected to your Spotify account.</p></div>
            <p>&nbsp;</p>

        <p>14) Does any information about the ratings go from Song Carousel to Spotify?</p>
            <p>&nbsp;</p>
            <div className="answer"><p>No, only you see the ratings you receive. Spotify only sees regular Song Plays. No information about your Songcarousel.com ratings goes to Spotify.</p></div>
            <p>&nbsp;</p>
                 <p>&nbsp;</p>



        </h2>
                

   

            </div>
            

     


    </div>
  );
}

export default FaqSlideBody;
